angular.module('ui.user.profile', [])

    .config(function ($stateProvider, customTemplateResolverProvider) {
        $stateProvider.state('client.userprofile', {
            url: '/profile',
            template: customTemplateResolverProvider.get('profile.html', 'app/ui/user/profile/profile.html'),
            controller: 'UserProfileController',
            data: {pageTitle: 'OrderManager: User Profile'}
        });
    })

    .controller('UserProfileController', function ($rootScope, $scope, $state, $log, gettextCatalog, toastr, usersRepository, appLocale, rest, authService, serverLocalization) {

        $scope.passwordValidationRegex = /.*/g;
        $scope.passwordValidationMessage = "";

        $scope.titles = [
            gettextCatalog.getString('Mr.'),
            gettextCatalog.getString('Ms.'),
            gettextCatalog.getString('Mrs.'),
            gettextCatalog.getString('Dr.')
        ];

        rest.events.on("modelUpdated", function (model) {
            if (model && model == $scope.restUser) {
                $scope.restUser = $scope.restUser; // force scope renew
            }
        });
        //Declare a handler to reset user object in case of leaving the User Profile view without saving user first
        $rootScope.$on("$stateChangeStart", function (event, toState, toParams, fromState, fromParams) {
            if (fromState.name === "client.userprofile" && $scope.restUser.isDirty()) {
                $scope.restUser.reset();
            }
        });

        usersRepository.getCurrentUser()
            .then(function (user) {
                $scope.restUser = user;
            });

        //We need to get list of OM server supported languages, then we need to match it agains 
        //UI translations supported languages and finally allow user to choose only those languages
        //that supported both by OM server and localisation (have translations actually)
        appLocale.getLanguagesList().then(function(serverSupportedLanguages) {
            appLocale.getTranslatedLanguageList().then(
                function(hash) {
                    var list = [];
                    list.push({ name: gettextCatalog.getString('Select Language...'), code: null });

                    for (var key in hash) {
                        if (hash.hasOwnProperty(key) && _.indexOf(serverSupportedLanguages, key) !== -1) {
                            list.push({
                                name: hash[key],
                                code: key
                            });
                        }
                    }
                    $scope.languages = list;
                },
                function(err) {
                    toastr.warning(gettextCatalog.getString("Can't load list of available languages"), err);
                });
        });

        $scope.saveAndClose = function () { // todo model validation
            if (!$scope.restUser) {
                return;
            }
            usersRepository.saveCurrentUser()
                .then(function () {
                    return appLocale.setCurrentLanguageFromCurrentUser()
                        .catch(function () {
                            toastr.error(_.str.sprintf(gettextCatalog.getString("Can't set system language to %s"), appLocale.getCurrentLanguage()));
                        });
                },
                function () {
                    toastr.error('We were unable to save user');
                })
                .then(function () {
                    $state.go('client.home'); // redirect back to home
                    toastr.success(gettextCatalog.getString('Profile updated!'));
                }, function (error) {
                    $log.error('Error while setting current user language: %s', error);
                });
        };

        //region password changing

        //custom validation rule 'password equal'
        $scope.pwdValidatorOptions = {
            rules: {
                pwdequal: function (input) {
                    if (input.is("[name=confirmNewPwd]")) {
                        return input.val() === $scope.newPwd;
                    }
                    return true;
                }
            }
        };

        $scope.bringUpPasswordEditForm = function() {
            $scope.clearInput();
            $scope.changeOptions();

            //We need to get password validation regex and message to later use with kendo-validator
            authService.getPasswordValidationRegex().then(function (regex) {
                $scope.passwordValidationRegex = regex;
                $scope.passwordValidationMessage = gettextCatalog.getString("PasswordStrength.ValidationMessage");
                $scope.changePwdForm.open();
            });
        };

        //validates and performs changing
        $scope.changePwd = function () {
            if ($scope.pwdValidator.validate()) {
                authService.editPassword($scope.oldPwd, $scope.newPwd)
                    .then(function (result) {
                        toastr.success(gettextCatalog.getString('Password has been changed'), gettextCatalog.getString('Success'));
                        $scope.changePwdForm.close();
                    }, function (result) {
                        if (result.status = 400) {
                            toastr.error(gettextCatalog.getString('Old password is incorrect'), gettextCatalog.getString('Error'));
                        } else {
                            toastr.error(gettextCatalog.getString('Something went wrong.'), gettextCatalog.getString('Error'));
                        }

                    });
            }
        };

        $scope.clearInput = function () {
            $scope.oldPwd = '';
            $scope.newPwd = '';
            $scope.confirmNewPwd = '';
        };

        $scope.changePwdFormWidth = 300;

        //changes position before each rendering
        $scope.changeOptions = function () {
            $scope.changePwdForm.setOptions({
                position: {
                    top: '15%',
                    left: (jQuery(window).width() - $scope.changePwdFormWidth) / 2
                }
            });
        };

        //endregion

    });
